import { Component, Vue } from 'vue-property-decorator';
import * as MemberApiController from '../api/MemberApiController';
import { LoginModel } from '../api/viewmodels/LoginModel';

@Component
export default class Login extends Vue {

    username = '';
    password = '';

    showError: boolean = false;
    errorText: string = '';

    loading: boolean = false;

    login() {
        if (this.loading) {
            return;
        }
        this.loading = true;
        var newViewmodel: LoginModel =
        {
            email: this.username,
            password: this.password
        }

        MemberApiController.login(newViewmodel)
            .then((response) => {                
                if (response.status == 200 && response.data.success) {
                    this.showError = false;
                    this.$store.dispatch('setLoggedIn');
                    MemberApiController.getCurrentMemberName()
                        .then((result) => {
                            this.loading = false;
                            this.$store.dispatch('setUsername', result.data);
                            this.$router.push('Dashboard');
                        })
                        .catch((error) => {
                            this.errorText = 'Kon gebruikersinformatie niet ophalen. Probeer het opnieuw';
                            this.showError = true;
                            this.loading = false;
                        });
                }
                else {
                    // the api gives json back containing 'responsemessage' instead of 'responseMessage'. That's why we have to cast to any
                    this.errorText = (<any>response.data).responsemessage;
                    this.showError = true;
                    this.loading = false;
                }
            })
            .catch((error) => {
                this.loading = false;
                this.errorText = 'Er vond een fout plaats tijdens het inloggen. Probeer het opnieuw';
                this.showError = true;
            });
    }
}
